import React, { useEffect, useState } from "react";
import { Mail, Users } from "lucide-react";
import { adminApi } from "@/context/AdminAuthContext";
import { Card, PageTitle, Empty } from "@/admin/ui";

const fmt = (iso) => (iso ? new Date(iso).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" }) : "");

export default function InboxPage() {
  const [tab, setTab] = useState("messages");
  const [messages, setMessages] = useState([]);
  const [subs, setSubs] = useState([]);

  useEffect(() => {
    adminApi.get("/admin/messages").then(({ data }) => setMessages(data)).catch(() => {});
    adminApi.get("/admin/subscribers").then(({ data }) => setSubs(data)).catch(() => {});
  }, []);

  const markRead = async (m) => {
    if (m.read) return;
    setMessages((list) => list.map((x) => (x.id === m.id ? { ...x, read: true } : x)));
    adminApi.patch(`/admin/messages/${m.id}/read`).catch(() => {});
  };

  return (
    <div data-testid="admin-inbox-page">
      <PageTitle title="Inbox" sub="Messages from the Ask Nutribest form and newsletter signups." />
      <div className="flex gap-2 mb-6">
        {[["messages", Mail, `Messages (${messages.length})`], ["subscribers", Users, `Subscribers (${subs.length})`]].map(([key, Icon, label]) => (
          <button key={key} data-testid={`inbox-tab-${key}`} onClick={() => setTab(key)} className={`inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.14em] px-4 py-2.5 rounded-full border transition-colors ${tab === key ? "bg-forest text-cream border-forest" : "border-forest/20 text-forest hover:bg-forest/5"}`}>
            <Icon size={13} /> {label}
          </button>
        ))}
      </div>
      <Card className="overflow-hidden">
        {tab === "messages" ? (
          <>
            {messages.length === 0 && <Empty text="No messages yet." />}
            <ul className="divide-y divide-forest/10">
              {messages.map((m) => (
                <li key={m.id} data-testid={`inbox-message-${m.id}`} onClick={() => markRead(m)} className={`px-4 sm:px-6 py-4 cursor-pointer hover:bg-cream/60 ${m.read ? "" : "bg-[#FBF6E8]/60"}`}>
                  <div className="flex items-center justify-between gap-3">
                    <p className="text-sm font-semibold text-forest">{m.name} <span className="text-mutedgreen font-normal">· {m.email}</span></p>
                    <span className="text-[11px] text-mutedgreen shrink-0">{fmt(m.created_at)}</span>
                  </div>
                  <p className="text-[10px] font-bold uppercase tracking-[0.15em] text-gold mt-1">{m.topic}</p>
                  <p className="text-sm text-ink/80 mt-1.5 whitespace-pre-wrap">{m.message}</p>
                </li>
              ))}
            </ul>
          </>
        ) : (
          <>
            {subs.length === 0 && <Empty text="No subscribers yet." />}
            <ul className="divide-y divide-forest/10">
              {subs.map((s) => (
                <li key={s.id} className="flex items-center justify-between gap-3 px-4 sm:px-6 py-3">
                  <span className="text-sm text-forest">{s.email} {s.source === "waitlist" && <span className="ml-2 text-[9px] font-bold uppercase tracking-[0.15em] bg-[#FBF6E8] text-gold px-2 py-0.5 rounded-full">Launch waitlist</span>}</span>
                  <span className="text-[11px] text-mutedgreen">{fmt(s.created_at)}</span>
                </li>
              ))}
            </ul>
          </>
        )}
      </Card>
    </div>
  );
}
